import List from './list/ReferralReasonListInitialState'

const { Record } = require('immutable')

export default Record({
    list: List()
})